<div class="container mt-5">
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }

  <!-- A section to display all the config settings -->

  <table>
    
    <tr>
      <td><strong>Geoms URL:</strong></td>
      <td>{{geometriesUrl}}</td>
      <td><strong>Vis URL:</strong></td>
      <td>{{visUrl}}</td>
    </tr>
    <tr>
      <td><strong>Windings URL:</strong></td>
      <td>{{windingUrl}}</td>
      <td><strong>Queue URL:</strong></td>
      <td>{{queueUrl}}</td>
    </tr>
    <tr>
      <td><strong>API URL:</strong></td>
      <td>{{apiUrl}}</td>
    </tr>
    
  </table>
  <br/>
  
  
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="node_count">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nodes</th>
      <td mat-cell *matCellDef="let element"> {{element.node_count}} </td>
    </ng-container>

    <ng-container matColumnDef="cpu">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CPU usage (Cores)</th>
      <td mat-cell *matCellDef="let element"> {{element.current_cpu_cores}} / {{element.allocatable_cpu_cores}} </td>
    </ng-container>

    <ng-container matColumnDef="memory">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>RAM usage (GB)</th>
      <td mat-cell *matCellDef="let element"> {{element.current_memory_bytes/1073741824 | number:'1.0-0'}} / {{element.allocatable_memory_bytes/1073741824 | number:'1.0-0'}} </td>
    </ng-container>

    <ng-container matColumnDef="last_seen">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Seen</th>
      <td mat-cell *matCellDef="let element"> {{element.last_seen | date:'HH:mm:ss, dd MMM yyyy' }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
          <a (click)="deleteCluster(element.id)" href="javascript:void(0)">Delete&nbsp;</a>
          <a (click)="refreshCluster(element.id)" href="javascript:void(0)">Refresh</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of clusters">
  </mat-paginator>
</div>